import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { withRouter } from "react-router";
import { debouncePromise } from "../../util/debounce";
import PersonService from "../../services/PersonService";
import TeamService from "../../services/TeamService";
import Loading from "../shared/loading";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
// Static private members
const defaultErrorMessage = "We encountered an unkown error.";
class TeamForm extends Component {
    constructor(props) {
        super(props);
        this.renderCancelButton = () => {
            let url = "/aviso/team/list";
            if (this.props.teamId) {
                url = `/aviso/team/show/${this.props.teamId}`;
            }
            return (_jsx("a", { className: "btn btn-outline-secondary", href: url, 
                // @ts-expect-error - TS2322 - Type '{ children: string; className: string; href: string; disabled: boolean; }' is not assignable to type 'DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>'.
                disabled: this.state.isSaving, children: "Cancel" }));
        };
        this.onPersonSelected = this.onPersonSelected.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.searchUsers = this.searchUsers.bind(this);
        this.state = {
            isSaving: false,
            didSave: false,
            teamMembersFetch: {
                hasFetchError: false,
                errorMessage: "",
            },
            teamFetch: {
                hasFetchError: false,
                errorMessage: "",
                didLoad: false,
            },
            team: {
                name: "",
                description: "",
                active: false,
                members: [],
            },
        };
    }
    componentDidMount() {
        // Fetch team from id.
        if (this.props.teamId) {
            // TODO setting state from props.State of the team should be maintained outside of the form.
            this.fetchTeam(this.props.teamId);
        }
    }
    fetchTeam(id) {
        TeamService.getTeam(id)
            .then((team) => {
            // Update fetch state
            this.setState({
                teamFetch: {
                    hasFetchError: false,
                    errorMessage: "",
                    didLoad: true,
                },
            });
            // Set team values
            this.setState({
                team: {
                    id: team.id,
                    name: team.name,
                    description: team.description,
                    active: team.active,
                    members: team.members,
                },
            });
        })
            .catch((error) => {
            this.setState({
                teamFetch: {
                    hasFetchError: true,
                    errorMessage: typeof error === "string" ? error : defaultErrorMessage,
                    didLoad: false,
                },
            });
        });
    }
    onPersonSelected(people) {
        this.setState((prevState) => ({
            team: Object.assign(Object.assign({}, prevState.team), { members: people }),
            didSave: false,
        }));
        if (this.props.onChange) {
            this.props.onChange();
        }
    }
    handleChange(event) {
        const { target } = event;
        // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'EventTarget'. | TS2339 - Property 'checked' does not exist on type 'EventTarget'. | TS2339 - Property 'value' does not exist on type 'EventTarget'.
        const value = target.type === "checkbox" ? target.checked : target.value;
        // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'EventTarget'.
        const { name } = target;
        this.setState((prevState) => ({
            team: Object.assign(Object.assign({}, prevState.team), { [name]: value }),
            didSave: false,
        }));
        if (this.props.onChange) {
            this.props.onChange();
        }
    }
    searchUsers(input) {
        this.setState((prevState) => ({
            teamMembersFetch: Object.assign(Object.assign({}, prevState.teamMembersFetch), { hasFetchError: false }),
        }));
        return PersonService.listAsJson(input)
            .then((people) => ({ options: people }))
            .catch((error) => {
            this.setState({
                teamMembersFetch: {
                    hasFetchError: true,
                    errorMessage: typeof error === "string" ? error : defaultErrorMessage,
                },
            });
            return { options: [] };
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        // Form validation.
        if (!this.state.team.name) {
            if (this.props.onError) {
                this.props.onError("Name is a required field.");
            }
            return;
        }
        if (this.state.team.members.length === 0) {
            if (this.props.onError) {
                this.props.onError("Select at least one team member.");
            }
            return;
        }
        // Post team.
        this.setState({ isSaving: true });
        TeamService.saveTeam(this.state.team)
            .then((data) => {
            if (this.props.onSave) {
                this.props.onSave();
            }
            this.setState({ didSave: true });
        })
            .catch((error) => {
            const errorMessage = typeof error === "string" ? error : defaultErrorMessage;
            if (this.props.onError) {
                this.props.onError(errorMessage);
            }
        })
            // $FlowFixMe finally does exist on promise.
            .finally(() => {
            this.setState({ isSaving: false });
            // No reason to use history here since we're navigating to a gsp rendered page
            window.location.assign("/aviso/team/list");
        });
    }
    render() {
        if (this.props.teamId) {
            if (this.state.teamFetch.hasFetchError) {
                return (_jsxs("div", { className: "alert alert-danger", children: ["Could not load team: ", this.state.teamFetch.errorMessage] }));
            }
            if (!this.state.teamFetch.didLoad) {
                return _jsx(Loading, { isLoading: true });
            }
        }
        return (_jsxs("form", { onSubmit: this.handleSubmit, children: [_jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: "name", children: "Name" }), _jsx("input", { type: "text", className: "form-control boxed", name: "name", autoComplete: "off", value: this.state.team.name, onChange: this.handleChange, id: "name", required: true }), _jsx("small", { className: "text-muted form-text", children: "E.g. Success Coaches, Power Advisors, Nursing Instructors" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "description", children: "Description" }), _jsx("input", { type: "text", className: "form-control boxed", name: "description", value: this.state.team.description || "", onChange: this.handleChange, autoComplete: "off", id: "description" }), _jsx("small", { className: "text-muted form-text", children: "A more detailed description of the team and the reason they are being grouped together." })] }), _jsx("div", { className: "form-group", children: _jsxs("div", { className: "custom-control custom-checkbox", children: [_jsx("input", { type: "checkbox", name: "active", className: "custom-control-input", 
                                // @ts-expect-error - TS2322 - Type '{ type: "checkbox"; name: string; className: string; autocomplte: string; checked: boolean; onChange: (arg1: SyntheticEvent<Element, Event>) => void; id: string; }' is not assignable to type 'DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>'.
                                autocomplte: "off", checked: this.state.team.active, onChange: this.handleChange, id: "active" }), _jsx("label", { className: "custom-control-label", htmlFor: "active", children: "Active" }), _jsx("small", { className: "text-muted form-text", children: "Inactive teams are hidden from Aviso Engage users." })] }) }), _jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: "membersSelect", children: "Members" }), _jsx(DeprecatedSelect.Async, { "aria-label": "Members", loadOptions: debouncePromise(this.searchUsers, 300), name: "teamMembers", multi: true, onChange: this.onPersonSelected, value: this.state.team.members, valueKey: "affiliationId", id: "membersSelect", optionRenderer: (option) => {
                                return option.fullName + "  (" + option.studentId + ")";
                            }, required: true }), _jsx("small", { className: "text-muted form-text", children: "Add people to this team. At least one person is required." }), this.state.teamMembersFetch.hasFetchError && (_jsxs("div", { className: "alert alert-danger mt-2", children: ["Error fetching team members:", " ", this.state.teamMembersFetch.errorMessage] }))] }), !this.state.didSave && (_jsxs("div", { className: "form-group", children: [_jsxs("button", { type: "submit", className: "btn btn-primary mr-2", disabled: this.state.isSaving, children: [this.state.isSaving ? (_jsx("span", { className: "fal fa-circle-notch fa-spin mr-1", "aria-hidden": true })) : (_jsx("span", { className: "fas fa-save mr-1", "aria-hidden": true })), "Save"] }), this.renderCancelButton()] }))] }));
    }
}
export default withRouter(TeamForm);
